export default {
  // Tab names
  'tab.main': 'Principal',
  'tab.producers': 'Produtores',
  'tab.achievements': 'Conquistas',
  'tab.prestige': 'Prestigio',
  'tab.settings': 'Config.',

  // Header
  'header.bps': '/seg',
  'header.stage': 'Estagio',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': 'Combo',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': 'Semente',
  'producer.P2': 'Broto',
  'producer.P3': 'Muda',
  'producer.P4': 'Cafeeiro',
  'producer.P5': 'Fazenda Peq.',
  'producer.P6': 'Fazenda Grande',
  'producer.P7': 'Torrefacao',
  'producer.P8': 'Fabrica de Cafe',
  'producer.P9': 'Centro de Export.',
  'producer.P10': 'Franquia',
  'producer.P11': 'Imperio do Cafe',
  'producer.P12': 'Planeta Cafe',

  // Tap upgrades
  'upgrade.T1': 'Dedos Rapidos',
  'upgrade.T2': 'Luvas',
  'upgrade.T3': 'Ferramentas',
  'upgrade.T4': 'Maquinario',
  'upgrade.T5': 'Robo',
  'upgrade.T6': 'Nanotecnologia',
  'upgrade.T7': 'Colheita Quantica',
  'upgrade.T8': 'Distorcao Temporal',

  // Prestige upgrades
  'prestige.G1': 'Semente Dourada',
  'prestige.G1.desc': 'BPS +1 base',
  'prestige.G2': 'Solo Fertil',
  'prestige.G2.desc': 'Poder de toque x1.5',
  'prestige.G3': 'Desconto Inicial',
  'prestige.G3.desc': 'P1~P3 custo -50%',
  'prestige.G4': 'Crescimento Noturno',
  'prestige.G4.desc': 'Eficiencia offline +20%',
  'prestige.G5': 'Cultivo Rapido',
  'prestige.G5.desc': 'BPS total x2',
  'prestige.G6': 'Maos de Sorte',
  'prestige.G6.desc': 'Chance critica +3%',
  'prestige.G7': 'Barista Mestre',
  'prestige.G7.desc': 'Poder de toque x3',
  'prestige.G8': 'Desconto Atacado',
  'prestige.G8.desc': 'Todos os custos -20%',
  'prestige.G9': 'Inicio Rapido',
  'prestige.G9.desc': 'Comecar com 10 P1~P3',
  'prestige.G10': 'Blend Premium',
  'prestige.G10.desc': 'BPS total x3',
  'prestige.G11': 'Grao do Tempo',
  'prestige.G11.desc': 'Eficiencia offline 100%',
  'prestige.G12': 'Coroa do Rei do Cafe',
  'prestige.G12.desc': 'Producao total x2',
  'prestige.G13': 'Arvore de Graos Dourados',
  'prestige.G13.desc': 'Ganho de graos dourados +20%',
  'prestige.G14': 'Viagem no Tempo',
  'prestige.G14.desc': 'Comecar no estagio 5',
  'prestige.G15': 'Graos Infinitos',
  'prestige.G15.desc': 'Producao total x10',
  'prestige.G16': 'Big Bang do Cafe',
  'prestige.G16.desc': 'Ganho de graos dourados x2',

  // Star upgrades
  'star.S1': 'Fundo Inicial',
  'star.S1.desc': '1M graos no inicio',
  'star.S2': 'Ouro Eterno',
  'star.S2.desc': 'Graos dourados x2 permanente',
  'star.S3': 'Bencao das Estrelas',
  'star.S3.desc': 'BPS total x5 permanente',
  'star.S4': 'Auto Toque',
  'star.S4.desc': '1 toque auto por segundo',
  'star.S5': 'Mestre do Combo',
  'star.S5.desc': 'Duracao do combo 3 seg',
  'star.S6': 'Golpe Mortal',
  'star.S6.desc': 'Multiplicador critico x2',
  'star.S7': 'Poder Cosmico',
  'star.S7.desc': 'Producao total x10 permanente',
  'star.S8': 'Estrela Transcendente',
  'star.S8.desc': 'Bonus de ascensao x3',

  // Varieties
  'variety.V1': 'Arabica',
  'variety.V2': 'Robusta',
  'variety.V3': 'Liberica',
  'variety.V4': 'Excelsa',
  'variety.V5': 'Geisha',
  'variety.V6': 'Kopi Luwak',
  'variety.V7': 'Blue Mountain',
  'variety.V8': 'Kona',
  'variety.V9': 'Yirgacheffe',
  'variety.V10': 'Peaberry',
  'variety.V11': 'Maragogipe',
  'variety.V12': 'St. Helena',

  // Stages
  'stage.1': 'Jardim da Vovo',
  'stage.2': 'Pequeno Quintal',
  'stage.3': 'Fazenda de Cafe',
  'stage.4': 'Torrefacao',
  'stage.5': 'Fabrica de Cafe',
  'stage.6': 'Rede Global',
  'stage.7': 'Reino do Cafe',

  // Roasting
  'roast.perfect': 'Torra Perfeita!',
  'roast.dark': 'Torra Escura',
  'roast.medium': 'Torra Media',
  'roast.light': 'Torra Clara',
  'roast.burnt': 'Queimou...',
  'roast.raw': 'Cru demais',
  'roast.tap': 'Toque para parar!',
  'roast.reward': 'Recompensa',
  'roast.double': 'Ver anuncio para 2x!',
  'roast.collect': 'Coletar',

  // Achievements
  'ach.tap1': 'Primeiros Passos', 'ach.tap1.desc': '100 toques',
  'ach.tap2': 'Maos Ocupadas', 'ach.tap2.desc': '1.000 toques',
  'ach.tap3': 'Mestre do Toque', 'ach.tap3.desc': '10.000 toques',
  'ach.tap4': 'Dedo Lendario', 'ach.tap4.desc': '100.000 toques',
  'ach.tap5': 'Deus do Toque', 'ach.tap5.desc': '1.000.000 toques',
  'ach.tap6': 'Maos Rapidas', 'ach.tap6.desc': '5 toques por segundo',
  'ach.tap7': 'Maos Relampago', 'ach.tap7.desc': '10 toques por segundo',
  'ach.tap8': 'Maos Divinas', 'ach.tap8.desc': '15 toques por segundo',
  'ach.tap9': 'Maniaco do Combo', 'ach.tap9.desc': 'Alcancar 20 combo',
  'ach.tap10': 'Combo Lendario', 'ach.tap10.desc': 'Alcancar 50 combo',

  'ach.prod1': 'Primeira Colheita', 'ach.prod1.desc': 'Colher 1K graos',
  'ach.prod2': 'Pequena Conquista', 'ach.prod2.desc': 'Colher 100K graos',
  'ach.prod3': 'Fazenda Crescendo', 'ach.prod3.desc': 'Colher 10M graos',
  'ach.prod4': 'Magnata do Cafe', 'ach.prod4.desc': 'Colher 1B graos',
  'ach.prod5': 'Imperador do Cafe', 'ach.prod5.desc': 'Colher 1T graos',
  'ach.prod6': 'Inicio da Automacao', 'ach.prod6.desc': 'Alcancar 100 BPS',
  'ach.prod7': 'Fabrica Ativa', 'ach.prod7.desc': 'Alcancar 10K BPS',
  'ach.prod8': 'Revolucao Industrial', 'ach.prod8.desc': 'Alcancar 1M BPS',
  'ach.prod9': 'Producao Global', 'ach.prod9.desc': 'Alcancar 100M BPS',
  'ach.prod10': 'Producao Cosmica', 'ach.prod10.desc': 'Alcancar 10B BPS',

  'ach.bld1': 'Fazendeiro Novato', 'ach.bld1.desc': 'Ter 1 de P1~P4',
  'ach.bld2': 'Fazendeiro Intermediario', 'ach.bld2.desc': 'Ter 1 de P1~P8',
  'ach.bld3': 'Fazendeiro Mestre', 'ach.bld3.desc': 'Ter todos os produtores',
  'ach.bld4': 'Investimento Focado', 'ach.bld4.desc': 'Ter 10 de um tipo',
  'ach.bld5': 'Compra em Massa', 'ach.bld5.desc': 'Ter 25 de um tipo',
  'ach.bld6': 'Colecionador', 'ach.bld6.desc': 'Ter 50 de um tipo',
  'ach.bld7': 'Monopolista', 'ach.bld7.desc': 'Ter 100 de um tipo',
  'ach.bld8': 'Expansao do Negocio', 'ach.bld8.desc': '100 produtores no total',
  'ach.bld9': 'Imperio Corporativo', 'ach.bld9.desc': '500 produtores no total',
  'ach.bld10': 'Dominacao Mundial', 'ach.bld10.desc': '1000 produtores no total',

  'ach.pres1': 'Primeiro Renascimento', 'ach.pres1.desc': '1 prestigio',
  'ach.pres2': 'Gosto da Repeticao', 'ach.pres2.desc': '3 prestigios',
  'ach.pres3': 'Mestre do Prestigio', 'ach.pres3.desc': '5 prestigios',
  'ach.pres4': 'Ciclo Infinito', 'ach.pres4.desc': '10 prestigios',
  'ach.pres5': 'Anel Eterno', 'ach.pres5.desc': '20 prestigios',
  'ach.pres6': 'Especialista em Reencarnacao', 'ach.pres6.desc': '50 prestigios',
  'ach.pres7': 'Colheita Dourada', 'ach.pres7.desc': '10 graos dourados de uma vez',
  'ach.pres8': 'Tempestade Dourada', 'ach.pres8.desc': '100 graos dourados de uma vez',
  'ach.pres9': 'Speedrunner', 'ach.pres9.desc': 'Prestigio em 30 min',
  'ach.pres10': 'Renascimento Relampago', 'ach.pres10.desc': 'Prestigio em 15 min',

  'ach.spec1': 'Cacador de Cerejas', 'ach.spec1.desc': 'Tocar cereja dourada 1 vez',
  'ach.spec2': 'Maniaco de Cerejas', 'ach.spec2.desc': 'Tocar cereja dourada 10 vezes',
  'ach.spec3': 'Mestre das Cerejas', 'ach.spec3.desc': 'Tocar cereja dourada 50 vezes',
  'ach.spec4': 'Torra Iniciante', 'ach.spec4.desc': 'Torra perfeita 1 vez',
  'ach.spec5': 'Torra Especialista', 'ach.spec5.desc': 'Torra perfeita 10 vezes',
  'ach.spec6': 'Colecionador de Variedades', 'ach.spec6.desc': 'Coletar 5 variedades',
  'ach.spec7': 'Doutor em Cafe', 'ach.spec7.desc': 'Coletar todas as 12 variedades',
  'ach.spec8': 'Fazendeiro Dedicado', 'ach.spec8.desc': '1 hora de jogo total',
  'ach.spec9': 'Viciado em Cafe', 'ach.spec9.desc': '24 horas de jogo total',
  'ach.spec10': '7 Dias Seguidos', 'ach.spec10.desc': '7 dias consecutivos',

  'ach.mile1': 'Cafeicultor', 'ach.mile1.desc': 'Alcancar estagio 3',
  'ach.mile2': 'Empresario do Cafe', 'ach.mile2.desc': 'Alcancar estagio 5',
  'ach.mile3': 'Rei do Cafe', 'ach.mile3.desc': 'Alcancar estagio 7',
  'ach.mile4': 'Transcendente', 'ach.mile4.desc': 'Primeira ascensao estelar',
  'ach.mile5': 'Perfeccionista', 'ach.mile5.desc': 'Desbloquear 50 conquistas',

  // Achievement categories
  'ach.cat.tapping': 'Toques',
  'ach.cat.production': 'Producao',
  'ach.cat.producers': 'Produtores',
  'ach.cat.prestige': 'Prestigio',
  'ach.cat.special': 'Especial',
  'ach.cat.milestone': 'Marcos',

  // Prestige panel
  'prestige.title': 'Renascimento da Torra',
  'prestige.desc': 'Renasca para ganhar graos dourados e comecar mais forte!',
  'prestige.goldenBeans': 'Graos Dourados',
  'prestige.expected': 'Ganho Esperado',
  'prestige.rebirth': 'Renascer',
  'prestige.upgrades': 'Melhorias de Prestigio',
  'prestige.locked': 'Desbloqueia no estagio 7',
  'prestige.adBonus': 'Ver anuncio +30%',

  // Ascension panel
  'ascend.title': 'Ascensao Estelar',
  'ascend.desc': 'Ascenda para ganhar po estelar e transcender tudo!',
  'ascend.starDust': 'Po Estelar',
  'ascend.expected': 'Ganho Esperado',
  'ascend.ascend': 'Ascender',
  'ascend.upgrades': 'Melhorias Estelares',
  'ascend.locked': 'Requer 10 renascimentos + 100 graos dourados',

  // Settings
  'settings.bgm': 'Musica de Fundo',
  'settings.sfx': 'Efeitos Sonoros',
  'settings.vibration': 'Vibracao',
  'settings.language': 'Idioma',
  'settings.reset': 'Resetar Dados',
  'settings.resetConfirm': 'Tem certeza que deseja apagar todos os dados?',
  'settings.credits': 'Creditos',
  'settings.version': 'Versao',

  // Boost buttons
  'boost.tap': 'Impulso de Toque',
  'boost.bps': 'Impulso de Producao',

  // Offline
  'offline.title': 'Bem-vindo de volta!',
  'offline.earned': 'Ganhos Offline',
  'offline.time': 'Tempo Ausente',
  'offline.collect': 'Coletar',
  'offline.adX3': 'Ver anuncio x3',

  // General
  'buy': 'Comprar',
  'max': 'Max',
  'level': 'Nv.',
  'locked': 'Bloqueado',
  'owned': 'Possui',
  'on': 'ON',
  'off': 'OFF',
} as const;
